import { render, staticRenderFns } from "./DocumentInputDropzone.vue?vue&type=template&id=e2f2d290&"
import script from "./DocumentInputDropzone.vue?vue&type=script&lang=js&"
export * from "./DocumentInputDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports